import { Component } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AirportService } from '../Services/airport.service';
import { AirportProperties } from '../Models/AirportProperties';
import { PassengerInfoService } from '../Services/passengerInfo.service';

import { Countries } from '../Models/Countries';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
declare var $;
@Component({
    selector: 'app-airport-manage',
    templateUrl: './airport-manage.component.html',
    styleUrls: ['./airport-manage.component.css'],
    imports: [NavMenuComponent, FormsModule, NgSelectModule, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule]
})
/** AirportManage component*/
export class AirportManageComponent {
  /** AirportManage ctor */
  constructor(private userService: PassengerInfoService,private modalService: NgbModal, private NewSuccess: NgbModal, private FallSuccess: NgbModal, private updateModal: NgbModal, private airportService: AirportService) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg' as any
    }
  }


  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold", "font-size":"15px" });
    
  };
  modalOptions: NgbModalOptions;
  airportGetList: AirportProperties[]=[];
  newobj = new AirportProperties();
  createobj = new AirportProperties();
  oldCountryList: Countries[] = [];
  countryList: Countries[] = [];
  validateIata= false;
  validateIataupdate= false;
  ngOnInit() {
    this.getDataAirportAll();
   // console.log(123);
    this.getCountries();
  }

  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.oldCountryList = data;
        this.countryList = data;
        for (let i = 0; i < this.oldCountryList.length; i++) {
          var capitalize = this.oldCountryList[i].countryName.replace(
            /\w\S*/g,
            function (txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
            }

          );
          this.countryList[i].countryName = capitalize;
        }

      });
    }
    catch (e) {
      console.log(e);
    }
  }

  IataRegex() {
    var pattern = /^[A-Za-z]{3,3}$/;
    var iatacode1 = document.getElementById("iatacode1") as HTMLInputElement;

    if (iatacode1.value.match(pattern)) {
    
      document.getElementById("message1").innerHTML = '';
      document.getElementById("iatacode1").style.borderColor = "#ced4da";
      document.getElementById("iatacode1").style.boxShadow = "";
      /*  A filename cannot contain any of the following characters: \/:*?"<>|');*/
      this.validateIata = true;
    }
    else {
      document.getElementById("message1").innerHTML = 'Allowed Only Three Characters';
      document.getElementById("iatacode1").style.borderColor = "red";
      document.getElementById("iatacode1").style.boxShadow = "0 0 3px red";
      this.validateIata = false;
    }
    return this.validateIata;
  }
  IataRegexUpdate() {
    var pattern = /^[A-Za-z]{3,3}$/;
    var iatacode1 = document.getElementById("iatacodew") as HTMLInputElement;

    if (iatacode1.value.match(pattern)) {

      document.getElementById("messagew").innerHTML = '';
      document.getElementById("iatacodew").style.borderColor = "#ced4da";
      document.getElementById("iatacodew").style.boxShadow = "";
      /*  A filename cannot contain any of the following characters: \/:*?"<>|');*/
      this.validateIataupdate = true;
    }
    else {
      document.getElementById("messagew").innerHTML = 'Allowed Only Three Characters';
      document.getElementById("iatacodew").style.borderColor = "red";
      document.getElementById("iatacodew").style.boxShadow = "0 0 3px red";
      this.validateIataupdate = false;
    }
    return this.validateIataupdate;
  }

  


  toTitleCaseofUpdate(str, e) {
    if (str == undefined) {
      return
    }
    var event = e.target.id;

  
    var iatacodeww = document.getElementById("iatacodew") as HTMLInputElement;
    var nameairww = document.getElementById("nameairportw") as HTMLInputElement;
    var cityww = document.getElementById("cityw") as HTMLInputElement;


    var iata2 = iatacodeww.id;
    var namea2 = nameairww.id;
    var citye2 = cityww.id;

   


    if (iata2 == event) {
      var capitalize = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );

      this.newobj.iataCode = capitalize;
    }
    if (namea2 == event) {
      var capitalize = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );

      this.newobj.airportName = capitalize;
    }
    if (citye2 == event) {
      var capitalize = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );

      this.newobj.city = capitalize;
    }
  }

  toTitleCase(str,e) {
    if (str == undefined) {
      return
    }
    var event = e.target.id;

    var iatacode1 = document.getElementById("iatacode1") as HTMLInputElement;
    var nameair1 = document.getElementById("nameairport1") as HTMLInputElement;
    var city1 = document.getElementById("city1") as HTMLInputElement;
    
    var iata1 = iatacode1.id;
    var namea1 = nameair1.id;
    var citye1 = city1.id;

    

    if (iata1 == event) {
      var capitalize = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );

      this.createobj.iataCode = capitalize;
    }
    if (namea1 == event) {
      var capitalize = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );

      this.createobj.airportName = capitalize;
    }
    if (citye1 == event) {
      var capitalize = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );

      this.createobj.city = capitalize;
    }



    
  }

  //SweetSuccess(targetmodel) {
  //  //this.FallSuccess.open(targetmodel, {

  //  //  windowClass: "alertpopupmodal"

  //  // /* size: 'modal-sm',*/
  //  //})
  //  this.NewSuccess.open(targetmodel, {

  //    /* windowClass: "searchpassengerpopupmodal"*/
  //    windowClass: "alertpopupmodal"
  //  })
  //  //setTimeout(() => { this.modalService.dismissAll() }, 5000);
  //}

  popupCreateModel(targetmodel) {
    this.modalService.open(targetmodel, {

     /* windowClass: "searchpassengerpopupmodal"*/
     
      size: 'lg',
    })
  }
  updatepopup(data, targetmodel) {
   //console.log(data);
    this.newobj.id = data.id;
    this.newobj.airportName = data.airportName;
  /*  this.newobj.ICAOCode = data.icaoCode;*/
    this.newobj.iataCode = data.iataCode;
    this.newobj.city = data.city;
    this.newobj.country = data.country;
    this.newobj.status = data.status;
  
    this.newobj.combineAirportFrom = data.combineAirportFrom;
    this.newobj.combineAirportTo = data.combineAirportTo;
    this.newobj.userId = Number(localStorage.getItem("UserId"));

    this.updateModal.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }

  getDataAirportAll() {
    this.airportService.GetAllAirport().subscribe((data) => {


      this.airportGetList = data;

    });
  }
  DeleteAirport(id, targetmodel, model) {
    //console.log(id);
    this.airportService.DeleteAirportDetails(id, Number(localStorage.getItem("UserId"))).subscribe((data) => {
      if (data == true) {
        this.getDataAirportAll();
        this.NewSuccess.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }
      else {
        this.FallSuccess.open(model, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
      }
    })
  }
  UpdateAirport(targetmodel, model) {
    if (this.IataRegexUpdate() == false) {
      return
    }
    if (this.newobj.airportName == "") {

      document.getElementById("messageAirportw").innerHTML = '*Required';
      document.getElementById("nameairportw").style.borderColor = "red";
      document.getElementById("nameairportw").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageAirportw").innerHTML = '';
      document.getElementById("nameairportw").style.borderColor = "#ced4da";
      document.getElementById("nameairportw").style.boxShadow = "";
    }
    if (this.newobj.city == "") {
      document.getElementById("messageCityw").innerHTML = '*Required';
      document.getElementById("cityw").style.borderColor = "red";
      document.getElementById("cityw").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageCityw").innerHTML = '';
      document.getElementById("cityw").style.borderColor = "#ced4da";
      document.getElementById("cityw").style.boxShadow = "";
    }
    if (this.newobj.country == null) {
      document.getElementById("countryrequiredw").innerHTML = '*Required';
      var country = document.querySelector(".countryrequired") as HTMLInputElement;
      country.style.borderColor = "red";
      var countrys = document.querySelector(".countryrequired") as HTMLInputElement;
      countrys.style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("countryrequiredw").innerHTML = '';
      var country = document.querySelector(".countryrequired") as HTMLInputElement;
      country.style.borderColor = "#ced4da";
      var countrys = document.querySelector(".countryrequired") as HTMLInputElement;
      countrys.style.boxShadow = "";
    }
    if (this.newobj.iataCode == "") {
      document.getElementById("messageiataw").innerHTML = '*Required';
      document.getElementById("iatacodew").style.borderColor = "red";
      document.getElementById("iatacodew").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageiataw").innerHTML = '';
      document.getElementById("iatacodew").style.borderColor = "#ced4da";
      document.getElementById("iatacodew").style.boxShadow = "";
    }
    if (this.newobj.status == "") {
      document.getElementById("messagestatusw").innerHTML = '*Required';
      document.getElementById("status1").style.borderColor = "red";
      document.getElementById("status1").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messagestatusw").innerHTML = '';
      document.getElementById("status1").style.borderColor = "#ced4da";
      document.getElementById("status1").style.boxShadow = "";
    }
    
     if ( this.newobj.combineAirportFrom == "") {
      
      document.getElementById("messagecombineAirportFrom2").innerHTML = '*Required';
      document.getElementById("combineAirportFrom2").style.borderColor = "red";
      document.getElementById("combineAirportFrom2").style.boxShadow = "0 0 3px red";
    

    }
    else {
      document.getElementById("messagecombineAirportFrom2").innerHTML = '';
      document.getElementById("combineAirportFrom2").style.borderColor = "";
      document.getElementById("combineAirportFrom2").style.boxShadow = "";
    }
     if ( this.newobj.combineAirportTo == "") {
      
      document.getElementById("messagecombineAirportTo2").innerHTML = '*Required';
      document.getElementById("combineAirportTo2").style.borderColor = "red";
      document.getElementById("combineAirportTo2").style.boxShadow = "0 0 3px red";
    

    }
    else {
      document.getElementById("messagecombineAirportTo2").innerHTML = '';
      document.getElementById("combineAirportTo2").style.borderColor = "";
      document.getElementById("combineAirportTo2").style.boxShadow = "";
    }
  
    if (this.newobj.airportName != "" && this.newobj.city != "" && this.newobj.country != null && this.newobj.iataCode != "" && this.newobj.status != ""
    
    && this.newobj.combineAirportFrom != "" && this.newobj.combineAirportTo != ""
    
    ) {
      this.newobj.userId = Number(localStorage.getItem("UserId"));
      // console.log(this.newobj);
      this.airportService.UpdateAirportDetails(this.newobj).subscribe((data) => {
        if (data == true) {
          this.getDataAirportAll();
          this.updateModal.dismissAll();
          this.NewSuccess.open(targetmodel, {

            /* windowClass: "searchpassengerpopupmodal"*/

            windowClass: "alertpopupmodal"
          })
          setTimeout(() => { this.modalService.dismissAll() }, 5000);
        }
        else {
          this.FallSuccess.open(model, {

            /* windowClass: "searchpassengerpopupmodal"*/

            windowClass: "alertpopupmodal"
          })
        }
        //console.log(data);
      })
    }
  }

  CreateAirport(targetmodel, model) {
    if (this.IataRegex() == false) {
      return
    }
    if (this.createobj.airportName == undefined || this.createobj.airportName == "" || this.createobj.airportName == null) {

      document.getElementById("messageAirport1").innerHTML = '*Required';
      document.getElementById("nameairport1").style.borderColor = "red";
      document.getElementById("nameairport1").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageAirport1").innerHTML = '';
      document.getElementById("nameairport1").style.borderColor = "#ced4da";
      document.getElementById("nameairport1").style.boxShadow = "";
    }
    if (this.createobj.city == undefined || this.createobj.city == "" || this.createobj.city == null) {
      document.getElementById("messageCity1").innerHTML = '*Required';
      document.getElementById("city1").style.borderColor = "red";
      document.getElementById("city1").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageCity1").innerHTML = '';
      document.getElementById("city1").style.borderColor = "#ced4da";
      document.getElementById("city1").style.boxShadow = "";
    }
    if (this.createobj.country == undefined || this.createobj.country == "" || this.createobj.country == null) {
      document.getElementById("countryrequired1").innerHTML = '*Required';
      var country = document.querySelector(".countryrequired1") as HTMLInputElement;
      country.style.borderColor = "red";
      var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
      countrys.style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("countryrequired1").innerHTML = '';
      var country = document.querySelector(".countryrequired1") as HTMLInputElement;
      country.style.borderColor = "#ced4da";
      var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
      countrys.style.boxShadow = "";
    }
    if (this.createobj.iataCode == undefined || this.createobj.iataCode == "" || this.createobj.iataCode == null) {
      document.getElementById("messageiata1").innerHTML = '*Required';
      document.getElementById("iatacode1").style.borderColor = "red";
      document.getElementById("iatacode1").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageiata1").innerHTML = '';
      document.getElementById("iatacode1").style.borderColor = "#ced4da";
      document.getElementById("iatacode1").style.boxShadow = "";
    }

  
    if ( this.createobj.combineAirportFrom == ""|| this.createobj.combineAirportFrom==undefined || this.createobj.combineAirportFrom==null) {
      
      document.getElementById("messagecombineAirportFrom1").innerHTML = '*Required';
      document.getElementById("combineAirportFrom1").style.borderColor = "red";
      document.getElementById("combineAirportFrom1").style.boxShadow = "0 0 3px red";
    

    }
    else {
      document.getElementById("messagecombineAirportFrom1").innerHTML = '';
      document.getElementById("combineAirportFrom1").style.borderColor = "";
      document.getElementById("combineAirportFrom1").style.boxShadow = "";
    }
     if ( this.createobj.combineAirportTo == ""||this.createobj.combineAirportTo==undefined || this.createobj.combineAirportTo==null) {
      
      document.getElementById("messagecombineAirportTo1").innerHTML = '*Required';
      document.getElementById("combineAirportTo1").style.borderColor = "red";
      document.getElementById("combineAirportTo1").style.boxShadow = "0 0 3px red";
    

    }
    else {
      document.getElementById("messagecombineAirportTo1").innerHTML = '';
      document.getElementById("combineAirportTo1").style.borderColor = "";
      document.getElementById("combineAirportTo1").style.boxShadow = "";
    }
    
    
    if (this.createobj.airportName != undefined && this.createobj.airportName != "" && this.createobj.airportName != null &&
      this.createobj.city != undefined && this.createobj.city != "" && this.createobj.city != null &&
      this.createobj.country != undefined && this.createobj.country != "" && this.createobj.country != null &&
      this.createobj.iataCode != undefined && this.createobj.iataCode != "" && this.createobj.iataCode != null
    
      && this.createobj.combineAirportFrom != ""&& this.createobj.combineAirportFrom!=undefined && this.createobj.combineAirportFrom!=null
      && this.createobj.combineAirportTo != ""&& this.createobj.combineAirportTo!=undefined && this.createobj.combineAirportTo!=null
      
    ) {
      this.newobj.userId = Number(localStorage.getItem("UserId"));
      this.airportService.CreateAirportsData(this.createobj).subscribe((data) => {
        if (data == true) {
          this.getDataAirportAll();
          this.modalService.dismissAll();
          this.NewSuccess.open(targetmodel, {

            /* windowClass: "searchpassengerpopupmodal"*/

            windowClass: "alertpopupmodal"
          })
          setTimeout(() => { this.modalService.dismissAll() }, 5000);
        }
        else {
          this.FallSuccess.open(model, {

            /* windowClass: "searchpassengerpopupmodal"*/
            windowClass: "alertpopupmodal"
          })
        }

      })
    }
  }
}
